// LibraryContext.js
import { createContext } from 'react';

export const LibraryContext = createContext({
  branchcode: '',
  branchname: '',
});